import { Col, Container, Row, Stack } from "react-bootstrap"

const HireWebDeveloperContent = () => {  
    return (
                
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>
                            Hire Web Developers to Build Secure, Scalable & High-Performance Web Solutions
                        </h2>
                        <p>
                            Looking to build a robust website, custom web application, or a scalable eCommerce platform? Our skilled web developers are ready to turn your vision into a fully functional digital product — optimized for performance, scalability, and security.
                        </p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Why Hire Web Developers from Us?
                        </h2>
                        <ul>
                            <li>
                                <b>
                                    Full-Stack Expertise
                                </b>
                                <p>
                                    From frontend UI to backend logic, our developers are proficient in HTML, CSS, JavaScript, PHP, Laravel, Node.js, React, and more.
                                </p>
                            </li>
                            <li>
                                <b>
                                    CMS & eCommerce Development
                                </b>
                                <p>
                                    We build custom solutions using WordPress, Magento, Shopify, and Laravel, tailored to your business model and customer needs.
                                </p>
                            </li>
                            <li>
                                <b>
                                    Secure & Scalable Codebase
                                </b>
                                <p>
                                    We follow best practices to ensure your web application is secure, maintainable, and built to scale as your business grows.
                                </p>
                            </li>
                            <li>
                                <b>
                                    API & Database Integration
                                </b>
                                <p>
                                    Seamless integration with REST APIs, third-party services, and databases (MySQL, MongoDB) for powerful dynamic web apps.
                                </p>
                            </li>
                            <li>
                                <b>
                                    Flexible Hiring Models
                                </b>
                                <p>
                                    Choose hourly, part-time, or full-time engagement options — depending on your timeline, budget, and project complexity.
                                </p>
                            </li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>Our Web Development Services</h2>
                        <ul>
                            <li>Full-Stack Web Application Development</li>
                            <li>Custom Website Development (Static & Dynamic)</li>
                            <li>CMS Development (WordPress, Magento, etc.)</li>
                            <li>API Integration & Backend Development</li>
                            <li>E-commerce Website Development</li>
                            <li>Web Maintenance & Performance Optimization</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Ready to Build Something Great?
                        </h2>
                        <p>
                            Whether you're a startup or an established business, our developers can help you launch faster and smarter. Contact us today for a free consultation and quote.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default HireWebDeveloperContent;